import { css } from "lit-element";

export const StofwareLinks = css`
	a,
	a:visited {
		text-decoration: none;
		color: var(--app-accent, var(--app-primary));
	}
`;
